const { analyticsEventBus, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const pushEvent = require('../pushEvent');

/* -------------------------------------------------------------------------- *\
 * MODALS EVENTS                                                              *
 * - Close cart recovery                                                      *
 * - Login cart recovery                                                      *
 * - Show cart recovery                                                       *
 * - Click Global-e option                                                    *
 * - Show redirect market                                                     *
 * - Click on redirect market                                                 *
 * - Show Vertex invalid address                                              *
 * - Close Vertex suggested address                                           *
 * - Confirm Vertex suggested address                                         *
 * - Edit Vertex suggested address                                            *
 * - Show Vertex suggested address                                            *
 * - Click Worldwide selector                                                 *
 * - Show Worldwide selector                                                  *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  // Close cart recovery modal
  analyticsEventBus.subscribe(ANALYTICS_EVENTS.modalCartRecoveryClosed, () => {
    pushEvent(
      createCustomEventGA4('cart_recovery_popup', [['action', 'close']])
    );
  });

  // Login link clicked in cart recovery modal
  analyticsEventBus.subscribe(ANALYTICS_EVENTS.modalCartRecoveryLogged, (e) => {
    if (e.detail?.referrer === 'cartRecovery') {
      pushEvent(
        createCustomEventGA4('cart_recovery_popup', [['action', 'login']])
      );
    }
  });

  // Show cart recovery modal
  analyticsEventBus.subscribe(ANALYTICS_EVENTS.modalCartRecoveryOpened, () => {
    pushEvent(
      createCustomEventGA4('cart_recovery_popup', [['action', 'impression']])
    );
  });

  // Click Global-e option
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.modalGlobalEOptionClicked,
    (payload) => {
      pushEvent(
        createCustomEventGA4('country_selector', [
          ['action', 'click'],
          ['type', 'global-e'],
          ['item', payload.selection],
          ['country', payload.site],
        ])
      );
    }
  );

  // Show redirect market modal
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.modalRedirectMarketOpened,
    (payload) => {
      pushEvent(
        createCustomEventGA4('country_selector', [
          ['action', 'impression'],
          ['type', payload.type],
        ])
      );
    }
  );

  // Click on redirect market modal
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.modalRedirectMarketOptionClicked,
    (payload) => {
      pushEvent(
        createCustomEventGA4('country_selector', [
          ['action', 'click'],
          ['type', payload.type],
          ['item', payload.item],
          ['url', payload.url],
        ])
      );
    }
  );

  // Show Vertex invalid address modal
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.modalVertexInvalidAddressOpened,
    () => {
      pushEvent(
        createCustomEventGA4('vertex_shipping_modal', [
          ['item', 'invalid_address'],
          ['action', 'show'],
        ])
      );
    }
  );

  // Close Vertex suggested address modal
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.modalVertexSuggestedAddressClosed,
    () => {
      pushEvent(
        createCustomEventGA4('vertex_shipping_modal', [
          ['item', 'confirm_address'],
          ['action', 'close'],
        ])
      );
    }
  );

  // Confirm Vertex suggested address modal
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.modalVertexSuggestedAddressConfirmed,
    () => {
      pushEvent(
        createCustomEventGA4('vertex_shipping_modal', [
          ['item', 'confirm_address'],
          ['action', 'confirm'],
        ])
      );
    }
  );

  // Edit Vertex suggested address modal
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.modalVertexSuggestedAddressEdited,
    () => {
      pushEvent(
        createCustomEventGA4('vertex_shipping_modal', [
          ['item', 'confirm_address'],
          ['action', 'edit'],
        ])
      );
    }
  );

  // Show Vertex suggested address modal
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.modalVertexSuggestedAddressOpened,
    () => {
      pushEvent(
        createCustomEventGA4('vertex_shipping_modal', [
          ['item', 'confirm_address'],
          ['action', 'show'],
        ])
      );
    }
  );

  // Click worldwide selector modal
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.modalWorldwideSelectorClicked,
    (payload) => {
      pushEvent(
        createCustomEventGA4('selector_worldwide', [
          ['action', 'click'],
          ['item', payload.site],
        ])
      );
    }
  );

  // Show worldwide selector modal
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.modalWorldwideSelectorOpened,
    () => {
      pushEvent(
        createCustomEventGA4('selector_worldwide', [['action', 'impression']])
      );
    }
  );
}

module.exports = {
  subscribeToAnalyticsEvents,
};
